module.exports = jQuery;


/*****************
 ** WEBPACK FOOTER
 ** external "jQuery"
 ** module id = 55
 ** module chunks = 0
 **/